import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import isLoggedIn from '../../../utils/auth';
import {formatDiamondTitle, formatNumber, formatCarat, formatShape, formatPrice, formatCost, formatCut, formatColor, formatClarity, formatSymmetry, formatPolish, formatLocation, getLocationId, formatMeasurements} from '../../../utils/formatting';

import scrollToComponent from 'react-scroll-to-component';

import * as diamondsActionCreators from '../../../actions/diamonds';
let allActionCreators = Object.assign({}, diamondsActionCreators);


class DiamondsOnline extends React.Component {

	constructor(props) {
		super(props);

    const CARAT_MIN = 0.5;
    const CARAT_MAX = 20;
    const PRICE_MIN = 0;
    const PRICE_MAX = 1000000;
    const COST_MIN = 0;
    const COST_MAX = 1000000;
    const TABLE_MIN = 0;
    const TABLE_MAX = 100;

    const LENGTH_MIN = 0;
    const LENGTH_MAX = 100;
    const WIDTH_MIN = 0;
    const WIDTH_MAX = 100;
    const HEIGHT_MIN = 0;
    const HEIGHT_MAX = 100;

    const DEPTH_MIN = 0;
    const DEPTH_MAX = 100;
    const RATIO_MIN = 0;
    const RATIO_MAX = 5;

    let locationsArray = ['All'];
    
    if(this.props.diamonds.diamondFilter.locations && this.props.diamonds.diamondFilter.locations != 'All') {
      locationsArray = [];

      try {
        let tempLocations = this.props.diamonds.diamondFilter.locations.toString().split(',');
        for(let i = 0; i < tempLocations.length; i++) {
          locationsArray.push(parseInt(tempLocations[i]))
        }
      } 
      catch(err) {
        console.error(err);
      }
    }

    this.state = {
      advancedOpen: false,
      isNatural: this.props.diamonds.diamondFilter.isNaturalDiamond === false ? false : true,
      shape: {
        ROUNDS: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('ROUNDS') : false,
        OVALS: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('OVALS') : false,
        EMERALD: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('EMERALD') : false,
        PEAR: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('PEAR SHAPE') : false,
        CUSHION: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('CUSHION') : false,
        PRINCESS: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('SQUARE OR PRINCESS') : false,
        RADIANT: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('RADIANT') : false,
        MARQUISE: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('MARQUISE') : false,
        ASCHER: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('ASCHER') : false,
        HEART: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('HEART SHAPE') : false,
        LAMOUR: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes("L'AMOUR CUT") : false,
        DAUSSI: this.props.diamonds.diamondFilter.shape ? this.props.diamonds.diamondFilter.shape.includes('DAUSSI CUSHION') : false,
      },
      cut: this.props.diamonds.diamondFilter.cut && this.props.diamonds.diamondFilter.cut.length > 0 ? this.props.diamonds.diamondFilter.cut.split(',') : ['All'],
      lab: this.props.diamonds.diamondFilter.lab && this.props.diamonds.diamondFilter.lab.length > 0 ? this.props.diamonds.diamondFilter.lab.split(',') : ['All'],
      color: this.props.diamonds.diamondFilter.color && this.props.diamonds.diamondFilter.color.length > 0 ? this.props.diamonds.diamondFilter.color.split(',') : ['All'],
      clarity: this.props.diamonds.diamondFilter.clarity && this.props.diamonds.diamondFilter.clarity.length > 0 ? this.props.diamonds.diamondFilter.clarity.split(',') : ['All'],
      ownership: this.props.diamonds.diamondFilter.ownership && this.props.diamonds.diamondFilter.ownership.length > 0 ? this.props.diamonds.diamondFilter.ownership.split(',') : ['All'],
      polish: this.props.diamonds.diamondFilter.polish && this.props.diamonds.diamondFilter.polish.length > 0 ? this.props.diamonds.diamondFilter.polish.split(',') : ['All'],
      symmetry: this.props.diamonds.diamondFilter.symmetry && this.props.diamonds.diamondFilter.symmetry.length > 0 ? this.props.diamonds.diamondFilter.symmetry.split(',') : ['All'],
      flourescence: this.props.diamonds.diamondFilter.flourescence && this.props.diamonds.diamondFilter.flourescence.length > 0 ? this.props.diamonds.diamondFilter.flourescence.split(',') : ['All'],
      locations: locationsArray,
      assets: this.props.diamonds.diamondFilter.assets && this.props.diamonds.diamondFilter.assets.length > 0 ? this.props.diamonds.diamondFilter.assets.split(',') : ['All'],
      wallet: this.props.diamonds.diamondFilter.wallet && this.props.diamonds.diamondFilter.wallet.length > 0 ? this.props.diamonds.diamondFilter.wallet.split(',') : ['All'],

      searchTerm: this.props.diamonds.diamondFilter.search_term ? this.props.diamonds.diamondFilter.search_term : '',

      caratMin: this.props.diamonds.diamondFilter.carat_min && this.props.diamonds.diamondFilter.carat_min != CARAT_MIN ? this.props.diamonds.diamondFilter.carat_min : CARAT_MIN,
      caratMax: this.props.diamonds.diamondFilter.carat_max && this.props.diamonds.diamondFilter.carat_max != CARAT_MAX ? this.props.diamonds.diamondFilter.carat_max : '',
      priceMin: this.props.diamonds.diamondFilter.price_min && this.props.diamonds.diamondFilter.price_min != PRICE_MIN ? this.props.diamonds.diamondFilter.price_min : '',
      priceMax: this.props.diamonds.diamondFilter.price_max && this.props.diamonds.diamondFilter.price_max != PRICE_MAX ? this.props.diamonds.diamondFilter.price_max : '',
      costMin: this.props.diamonds.diamondFilter.cost_min && this.props.diamonds.diamondFilter.cost_min != COST_MIN ? this.props.diamonds.diamondFilter.cost_min : '',
      costMax: this.props.diamonds.diamondFilter.cost_max && this.props.diamonds.diamondFilter.cost_max != COST_MAX ? this.props.diamonds.diamondFilter.cost_max : '',
      
      lengthMin: this.props.diamonds.diamondFilter.length_min && this.props.diamonds.diamondFilter.length_min != LENGTH_MIN ? this.props.diamonds.diamondFilter.length_min : '',
      lengthMax: this.props.diamonds.diamondFilter.length_max && this.props.diamonds.diamondFilter.length_max != LENGTH_MAX ? this.props.diamonds.diamondFilter.length_max : '',
      widthMin: this.props.diamonds.diamondFilter.width_min && this.props.diamonds.diamondFilter.width_min != WIDTH_MIN ? this.props.diamonds.diamondFilter.width_min : '',
      widthMax: this.props.diamonds.diamondFilter.width_max && this.props.diamonds.diamondFilter.width_max != WIDTH_MAX ? this.props.diamonds.diamondFilter.width_max : '',
      heightMin: this.props.diamonds.diamondFilter.height_min && this.props.diamonds.diamondFilter.height_min != HEIGHT_MIN ? this.props.diamonds.diamondFilter.height_min : '',
      heightMax: this.props.diamonds.diamondFilter.height_max && this.props.diamonds.diamondFilter.height_max != HEIGHT_MAX ? this.props.diamonds.diamondFilter.height_max : '',

      tableMin: this.props.diamonds.diamondFilter.table_min && this.props.diamonds.diamondFilter.table_min != TABLE_MIN ? this.props.diamonds.diamondFilter.table_min : '',
      tableMax: this.props.diamonds.diamondFilter.table_max && this.props.diamonds.diamondFilter.table_max != TABLE_MAX ? this.props.diamonds.diamondFilter.table_max : '',
      depthMin: this.props.diamonds.diamondFilter.depth_min && this.props.diamonds.diamondFilter.depth_min != DEPTH_MIN ? this.props.diamonds.diamondFilter.depth_min : '',
      depthMax: this.props.diamonds.diamondFilter.depth_max && this.props.diamonds.diamondFilter.depth_max != DEPTH_MAX ? this.props.diamonds.diamondFilter.depth_max : '',
      ratioMin: this.props.diamonds.diamondFilter.ratio_min && this.props.diamonds.diamondFilter.ratio_min != RATIO_MIN ? this.props.diamonds.diamondFilter.ratio_min : '',
      ratioMax: this.props.diamonds.diamondFilter.ratio_max && this.props.diamonds.diamondFilter.ratio_max != RATIO_MAX ? this.props.diamonds.diamondFilter.ratio_max : '',

      caratMinDefault: CARAT_MIN,
      caratMaxDefault: CARAT_MAX,
      priceMinDefault: PRICE_MIN,
      priceMaxDefault: PRICE_MAX,
      costMinDefault: COST_MIN,
      costMaxDefault: COST_MAX,
      tableMinDefault: TABLE_MIN,
      tableMaxDefault: TABLE_MAX,
      depthMinDefault: DEPTH_MIN,
      depthMaxDefault: DEPTH_MAX,
      ratioMinDefault: RATIO_MIN,
      ratioMaxDefault: RATIO_MAX,

      lengthMinDefault: LENGTH_MIN,
      lengthMaxDefault: LENGTH_MAX,
      widthMinDefault: WIDTH_MIN,
      widthMaxDefault: WIDTH_MAX,
      heightMinDefault: HEIGHT_MIN,
      heightMaxDefault: HEIGHT_MAX,
    }

    // Remove any previous results
    this.props.diamondsSave(null);
	}

  onlyRoundSelected() {
    if(!this.state.shape.ROUNDS) {
      return false;
    }
    if(this.state.shape.OVALS) {
      return false;
    }
    if(this.state.shape.EMERALD) {
      return false;
    }
    if(this.state.shape.PEAR) {
      return false;
    }
    if(this.state.shape.CUSHION) {
      return false;
    }
    if(this.state.shape.PRINCESS) {
      return false;
    }
    if(this.state.shape.RADIANT) {
      return false;
    }
    if(this.state.shape.MARQUISE) {
      return false;
    }
    if(this.state.shape.ASCHER) {
      return false;
    }
    if(this.state.shape.HEART) {
      return false;
    }
    if(this.state.shape.LAMOUR) {
      return false;
    }
    if(this.state.shape.DAUSSI) {
      return false;
    }
    return true;
  }

  userNav(page) {
    history.push('/' + page);
  }

  getShapeIconClass(shape) {
    return this.state.shape[shape] ? 'shapeIcon selected ' + shape : 'shapeIcon ' + shape;
  }

  setNatural(val) {
    this.setState({
      isNatural: val,
    });
  }

  toggleShape(shape) {
    let newShape = JSON.parse(JSON.stringify(this.state.shape));
    newShape[shape] = !newShape[shape];
    this.setState({ 
      shape: newShape 
    }, () => {
      if(!this.onlyRoundSelected()) {
        this.setState({ cut: ['All'] });
      }
    });
  }

  cloneArray(source) {
    let result = [];
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  setCut(cut) {
    if(cut === 'All') {
      this.setState({ cut: ['All'] });
      return;
    }
    if(this.state.cut.indexOf('All') > -1) {
      this.setState({ cut: [ cut ] });
      return;
    }

    let clone = this.cloneArray(this.state.cut);
    let i = this.state.cut.indexOf(cut);
    if(i === -1) {
      clone.push(cut);
      this.setState({ cut: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ cut: ['All'] });
      } else {
        this.setState({ cut: clone });
      }
    }
  }

  setLab(lab) {
    if(lab === 'All') {
      this.setState({ lab: ['All'] });
      return;
    }
    if(this.state.lab.indexOf('All') > -1) {
      this.setState({ lab: [ lab ] });
      return;
    }

    let clone = this.cloneArray(this.state.lab);
    let i = this.state.lab.indexOf(lab);
    if(i === -1) {
      clone.push(lab);
      this.setState({ lab: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ lab: ['All'] });
      } else {
        this.setState({ lab: clone });
      }
    }
  }

  setColor(color) {
    if(color === 'All') {
      this.setState({ color: ['All'] });
      return;
    }
    if(this.state.color.indexOf('All') > -1) {
      this.setState({ color: [ color ] });
      return;
    }

    let clone = this.cloneArray(this.state.color);
    let i = this.state.color.indexOf(color);
    if(i === -1) {
      clone.push(color);
      this.setState({ color: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ color: ['All'] });
      } else {
        this.setState({ color: clone });
      }
    }
  }

  setClarity(clarity) {
    if(clarity === 'All') {
      this.setState({ clarity: ['All'] });
      return;
    }
    if(this.state.clarity.indexOf('All') > -1) {
      this.setState({ clarity: [ clarity ] });
      return;
    }

    let clone = this.cloneArray(this.state.clarity);
    let i = this.state.clarity.indexOf(clarity);
    if(i === -1) {
      clone.push(clarity);
      this.setState({ clarity: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ clarity: ['All'] });
      } else {
        this.setState({ clarity: clone });
      }
    }
  }

  setLocations(location) {
    if(location === 'All') {
      this.setState({ locations: ['All'] });
      return;
    }
    if(this.state.locations.indexOf('All') > -1) {
      this.setState({ locations: [ location ] });
      return;
    }

    let clone = this.cloneArray(this.state.locations);
    let i = this.state.locations.indexOf(location);
    if(i === -1) {
      clone.push(location);
      this.setState({ locations: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ locations: ['All'] });
      } else {
        this.setState({ locations: clone });
      }
    }
  }

  setOwnership(ownership) {
    if(ownership === 'All') {
      this.setState({ ownership: ['All'] });
      return;
    }
    if(this.state.ownership.indexOf('All') > -1) {
      this.setState({ ownership: [ ownership ] });
      return;
    }

    let clone = this.cloneArray(this.state.ownership);
    let i = this.state.ownership.indexOf(ownership);
    if(i === -1) {
      clone.push(ownership);
      this.setState({ ownership: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ ownership: ['All'] });
      } else {
        this.setState({ ownership: clone });
      }
    }
  }

  setPolish(polish) {
    if(polish === 'All') {
      this.setState({ polish: ['All'] });
      return;
    }
    if(this.state.polish.indexOf('All') > -1) {
      this.setState({ polish: [ polish ] });
      return;
    }

    let clone = this.cloneArray(this.state.polish);
    let i = this.state.polish.indexOf(polish);
    if(i === -1) {
      clone.push(polish);
      this.setState({ polish: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ polish: ['All'] });
      } else {
        this.setState({ polish: clone });
      }
    }
  }

  setSymmetry(symmetry) {
    if(symmetry === 'All') {
      this.setState({ symmetry: ['All'] });
      return;
    }
    if(this.state.symmetry.indexOf('All') > -1) {
      this.setState({ symmetry: [ symmetry ] });
      return;
    }

    let clone = this.cloneArray(this.state.symmetry);
    let i = this.state.symmetry.indexOf(symmetry);
    if(i === -1) {
      clone.push(symmetry);
      this.setState({ symmetry: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ symmetry: ['All'] });
      } else {
        this.setState({ symmetry: clone });
      }
    }
  }

  setFluorescence(flourescence) {
    if(flourescence === 'All') {
      this.setState({ flourescence: ['All'] });
      return;
    }
    if(this.state.flourescence.indexOf('All') > -1) {
      this.setState({ flourescence: [ flourescence ] });
      return;
    }

    let clone = this.cloneArray(this.state.flourescence);
    let i = this.state.flourescence.indexOf(flourescence);
    if(i === -1) {
      clone.push(flourescence);
      this.setState({ flourescence: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ flourescence: ['All'] });
      } else {
        this.setState({ flourescence: clone });
      }
    }
  }

  setAssets(assets) {
    if(assets === 'All') {
      this.setState({ assets: ['All'] });
      return;
    }
    if(this.state.assets.indexOf('All') > -1) {
      this.setState({ assets: [ assets ] });
      return;
    }

    let clone = this.cloneArray(this.state.assets);
    let i = this.state.assets.indexOf(assets);
    if(i === -1) {
      clone.push(assets);
      this.setState({ assets: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ assets: ['All'] });
      } else {
        this.setState({ assets: clone });
      }
    }
  }

  setWallet(wallet) {
    if(wallet === 'All') {
      this.setState({ wallet: ['All'] });
      return;
    }
    if(this.state.wallet.indexOf('All') > -1) {
      this.setState({ wallet: [ wallet ] });
      return;
    }

    let clone = this.cloneArray(this.state.wallet);
    let i = this.state.wallet.indexOf(wallet);
    if(i === -1) {
      clone.push(wallet);
      this.setState({ wallet: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ wallet: ['All'] });
      } else {
        this.setState({ wallet: clone });
      }
    }
  }

  changeSearchTerm(evt) {
    this.setState({ searchTerm: evt.target.value });
  }

  changeCaratMin(evt) {
    this.setState({ caratMin: evt.target.value });
  }

  changeCaratMax(evt) {
    this.setState({ caratMax: evt.target.value });
  }

  changePriceMin(evt) {
    this.setState({ priceMin: evt.target.value });
  }

  changePriceMax(evt) {
    this.setState({ priceMax: evt.target.value });
  }

  changeCostMin(evt) {
    this.setState({ costMin: evt.target.value });
  }

  changeCostMax(evt) {
    this.setState({ costMax: evt.target.value });
  }

  changeTableMin(evt) {
    this.setState({ tableMin: evt.target.value });
  }

  changeTableMax(evt) {
    this.setState({ tableMax: evt.target.value });
  }

  changeLengthMin(evt) {
    this.setState({ lengthMin: evt.target.value });
  }

  changeLengthMax(evt) {
    this.setState({ lengthMax: evt.target.value });
  }

  changeWidthMin(evt) {
    this.setState({ widthMin: evt.target.value });
  }

  changeWidthMax(evt) {
    this.setState({ widthMax: evt.target.value });
  }

  changeHeightMin(evt) {
    this.setState({ heightMin: evt.target.value });
  }

  changeHeightMax(evt) {
    this.setState({ heightMax: evt.target.value });
  }


  changeDepthMin(evt) {
    this.setState({ depthMin: evt.target.value });
  }

  changeDepthMax(evt) {
    this.setState({ depthMax: evt.target.value });
  }

  changeRatioMin(evt) {
    this.setState({ ratioMin: evt.target.value });
  }

  changeRatioMax(evt) {
    this.setState({ ratioMax: evt.target.value });
  }

  validateCaratMin(evt) {
    let minValue = parseFloat(evt.target.value);
    let maxValue = this.state.caratMax === '' ? '' : parseFloat(this.state.caratMax);

    if(isNaN(minValue)) { minValue = this.state.caratMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.caratMaxDefault }

    if(minValue < this.state.caratMinDefault) {
      minValue = this.state.caratMinDefault;
    }
    if(minValue > 20) {
      minValue = 20;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      caratMin: minValue,
      caratMax: maxValue,
    });
  }

  validateCaratMax(evt) {
    let minValue = this.state.caratMin === '' ? '' : parseFloat(this.state.caratMin);
    let maxValue = parseFloat(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.caratMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.caratMaxDefault }

    if(maxValue < this.state.caratMinDefault) {
      maxValue = this.state.caratMinDefault;
    }
    if(maxValue > 20) {
      maxValue = 20;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      caratMin: minValue,
      caratMax: maxValue,
    });
  }

  validatePriceMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.priceMax === '' ? '' : parseInt(this.state.priceMax);

    if(isNaN(minValue)) { minValue = this.state.priceMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.priceMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 1000000) {
      minValue = 1000000;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      priceMin: minValue,
      priceMax: maxValue,
    });
  }

  validatePriceMax(evt) {
    let minValue = this.state.priceMin === '' ? '' : parseInt(this.state.priceMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.priceMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.priceMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 1000000) {
      maxValue = 1000000;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      priceMin: minValue,
      priceMax: maxValue,
    });
  }

  validateCostMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.costMax === '' ? '' : parseInt(this.state.costMax);

    if(isNaN(minValue)) { minValue = this.state.costMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.costMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 1000000) {
      minValue = 1000000;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      costMin: minValue,
      costMax: maxValue,
    });
  }

  validateCostMax(evt) {
    let minValue = this.state.costMin === '' ? '' : parseFloat(this.state.costMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.costMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.costMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 1000000) {
      maxValue = 1000000;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      costMin: minValue,
      costMax: maxValue,
    });
  }

  validateTableMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.tableMax === '' ? '' : parseInt(this.state.tableMax);

    if(isNaN(minValue)) { minValue = this.state.tableMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.tableMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 100) {
      minValue = 100;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      tableMin: minValue,
      tableMax: maxValue,
    });
  }

  validateTableMax(evt) {
    let minValue = this.state.tableMin === '' ? '' : parseFloat(this.state.tableMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.tableMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.tableMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 100) {
      maxValue = 100;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      tableMin: minValue,
      tableMax: maxValue,
    });
  }

  validateLengthMin(evt) {
    let minValue = parseFloat(evt.target.value);
    let maxValue = this.state.lengthMax === '' ? '' : parseFloat(this.state.lengthMax);

    if(isNaN(minValue)) { minValue = this.state.lengthMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.lengthMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 100) {
      minValue = 100;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      lengthMin: minValue,
      lengthMax: maxValue,
    });
  }

  validateLengthMax(evt) {
    let minValue = this.state.lengthMin === '' ? '' : parseFloat(this.state.lengthMin);
    let maxValue = parseFloat(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.lengthMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.lengthMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 100) {
      maxValue = 100;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      lengthMin: minValue,
      lengthMax: maxValue,
    });
  }

  validateWidthMin(evt) {
    let minValue = parseFloat(evt.target.value);
    let maxValue = this.state.widthMax === '' ? '' : parseFloat(this.state.widthMax);

    if(isNaN(minValue)) { minValue = this.state.widthMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.widthMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 100) {
      minValue = 100;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      widthMin: minValue,
      widthMax: maxValue,
    });
  }

  validateWidthMax(evt) {
    let minValue = this.state.widthMin === '' ? '' : parseFloat(this.state.widthMin);
    let maxValue = parseFloat(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.widthMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.widthMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 100) {
      maxValue = 100;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      widthMin: minValue,
      widthMax: maxValue,
    });
  }

  validateHeightMin(evt) {
    let minValue = parseFloat(evt.target.value);
    let maxValue = this.state.heightMax === '' ? '' : parseFloat(this.state.heightMax);

    if(isNaN(minValue)) { minValue = this.state.heightMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.heightMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 100) {
      minValue = 100;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      heightMin: minValue,
      heightMax: maxValue,
    });
  }

  validateHeightMax(evt) {
    let minValue = this.state.heightMin === '' ? '' : parseFloat(this.state.heightMin);
    let maxValue = parseFloat(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.heightMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.heightMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 100) {
      maxValue = 100;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      heightMin: minValue,
      heightMax: maxValue,
    });
  }

  validateDepthMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.depthMax === '' ? '' : parseInt(this.state.depthMax);

    if(isNaN(minValue)) { minValue = this.state.depthMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.depthMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 100) {
      minValue = 100;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      depthMin: minValue,
      depthMax: maxValue,
    });
  }

  validateDepthMax(evt) {
    let minValue = this.state.depthMin === '' ? '' : parseFloat(this.state.depthMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.depthMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.depthMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 100) {
      maxValue = 100;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      depthMin: minValue,
      depthMax: maxValue,
    });
  }

  validateRatioMin(evt) {
    let minValue = parseFloat(evt.target.value);
    let maxValue = this.state.ratioMax === '' ? '' : parseFloat(this.state.ratioMax);

    if(isNaN(minValue)) { minValue = this.state.ratioMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.ratioMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 5) {
      minValue = 5;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      ratioMin: minValue,
      ratioMax: maxValue,
    });
  }

  validateRatioMax(evt) {
    let minValue = this.state.ratioMin === '' ? '' : parseFloat(this.state.ratioMin);
    let maxValue = parseFloat(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.ratioMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.ratioMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 5) {
      maxValue = 5;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      ratioMin: minValue,
      ratioMax: maxValue,
    });
  }

  scrollToAdvanced() {
    scrollToComponent(this.priceBlock, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollToTop() {
    scrollToComponent(this.diamondMainBody, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'linear',
    });
  }

  toggleAdvanced() {
    this.setState({ advancedOpen: !this.state.advancedOpen }, () => {
      if(this.state.advancedOpen) {
        setTimeout(() => {
          this.scrollToAdvanced();
        }, 250);
      }
    });
  }

  createList(optionsArray) {

    let first = true;
    let optionList = '';

    if(optionsArray.length === 0) {
      return 'All';
    }

    for(let i = 0; i < optionsArray.length; i++) {
      if(first) {
        optionList = optionsArray[i];
      } else {
        optionList += ',' + optionsArray[i];
      }
      first = false;
    }
    return optionList;
  }

  createShapeList(optionsArray) {

    let first = true;
    let shapeList = '';

    let shapeKeys = Object.keys(this.state.shape);

    for(let i = 0; i < shapeKeys.length; i++) {

      if(this.state.shape[shapeKeys[i]]) {

        let key = shapeKeys[i];
        if(key === 'PEAR') {
          key = 'PEAR SHAPE';
        } else if(key === 'PRINCESS') {
          key = 'SQUARE OR PRINCESS';
        } else if(key === 'HEART') {
          key = 'HEART SHAPE';
        } else if(key === 'LAMOUR') {
          key = "L'AMOUR CUT";
        } else if(key === 'DAUSSI') {
          key = 'DAUSSI CUSHION';
        }

        if(first) {
          shapeList = key;
        } else {
          shapeList += ',' + key;
        }
        first = false;
      }
    }

    if(shapeList === '') {
      return 'All';
    } else {
      return shapeList;
    }
  }

  resetSearch(evt) {

    evt.stopPropagation();

    this.setState({
      shape: {
        ROUNDS: false,
        OVALS: false,
        EMERALD: false,
        PEAR: false,
        CUSHION: false,
        PRINCESS: false,
        RADIANT: false,
        MARQUISE: false,
        ASCHER: false,
        HEART: false,
        LAMOUR: false,
        DAUSSI: false,
      },
      cut: ['All'],
      lab: ['All'],
      color: ['All'],
      clarity: ['All'],
      ownership: ['All'],
      polish: ['All'],
      symmetry: ['All'],
      flourescence: ['All'],
      locations: ['All'],
      assets: ['All'],
      wallet: ['All'],

      searchTerm: '',

      caratMin: '',
      caratMax: '',
      priceMin: '',
      priceMax: '',
      costMin: '',
      costMax: '',
      lengthMin: '',
      lengthMax: '',
      widthMin: '',
      widthMax: '',
      heightMin: '',
      heightMax: '',
      tableMin: '',
      tableMax: '',
      depthMin: '',
      depthMax: '',
      ratioMin: '',
      ratioMax: '',
    }, () => {
      this.props.setDiamondFilters({});
      this.scrollToTop();
    })
  }

  handleSubmit() {

    let diamondFilter = {
      carat_min: this.state.caratMin === '' ? this.state.caratMinDefault : this.state.caratMin,
      carat_max: this.state.caratMax === '' ? this.state.caratMaxDefault : this.state.caratMax,
      price_min: this.state.priceMin === '' ? this.state.priceMinDefault : this.state.priceMin,
      price_max: this.state.priceMax === '' ? this.state.priceMaxDefault : this.state.priceMax,
      cost_min: this.state.costMin === '' ? this.state.costMinDefault : this.state.costMin,
      cost_max: this.state.costMax === '' ? this.state.costMaxDefault : this.state.costMax,
      length_min: this.state.lengthMin === '' ? this.state.lengthMinDefault : this.state.lengthMin,
      length_max: this.state.lengthMax === '' ? this.state.lengthMaxDefault : this.state.lengthMax,
      width_min: this.state.widthMin === '' ? this.state.widthMinDefault : this.state.widthMin,
      width_max: this.state.widthMax === '' ? this.state.widthMaxDefault : this.state.widthMax,
      height_min: this.state.heightMin === '' ? this.state.heightMinDefault : this.state.heightMin,
      height_max: this.state.heightMax === '' ? this.state.heightMaxDefault : this.state.heightMax,

      table_min: this.state.tableMin === '' ? this.state.tableMinDefault : this.state.tableMin,
      table_max: this.state.tableMax === '' ? this.state.tableMaxDefault : this.state.tableMax,
      depth_min: this.state.depthMin === '' ? this.state.depthMinDefault : this.state.depthMin,
      depth_max: this.state.depthMax === '' ? this.state.depthMaxDefault : this.state.depthMax,
      ratio_min: this.state.ratioMin === '' ? this.state.ratioMinDefault : this.state.ratioMin,
      ratio_max: this.state.ratioMax === '' ? this.state.ratioMaxDefault : this.state.ratioMax,

      shape: this.createShapeList(this.state.shape),
      cut: this.createList(this.state.cut),
      lab: this.createList(this.state.lab),
      color: this.createList(this.state.color),
      clarity: this.createList(this.state.clarity),
      ownership: this.createList(this.state.ownership),
      polish: this.createList(this.state.polish),
      symmetry: this.createList(this.state.symmetry),
      flourescence: this.createList(this.state.flourescence),
      locations: this.createList(this.state.locations),
      assets: this.createList(this.state.assets),
      wallet: this.createList(this.state.wallet),

      searchTerm: this.state.searchTerm,
      sort: 'price',

      isNaturalDiamond: this.state.isNatural,

      page: 1,
    }

    this.props.setDiamondFilters(diamondFilter);
    history.push('/results');
  }

	render() {

		return <div className='DiamondsOnline' ref={(div) => { this.diamondMainBody = div; }}>
			<div className={isLoggedIn() ? 'searchHeader loggedIn' : 'searchHeader'}>
        <div className='searchLabel'>Find Your Perfect Diamond</div>
        <div className='searchInput'>
          <input 
            type='text'
            placeholder='Search by diamond id or GIA number'
            value={this.state.searchTerm}
            onChange={this.changeSearchTerm.bind(this)} />
          <div className='searchIcon' onClick={this.handleSubmit.bind(this)}>
            <img src='/img/diamonds/magnify.svg' />
          </div>
        </div>
      </div>
      <div className='shapeBlock'>
        <div className='blockTitle'>Shape</div>
        <div className='shapeIconWrapper'>
          <div className={this.getShapeIconClass('ROUNDS')} onMouseDown={() => { this.toggleShape('ROUNDS') }}></div>
          <div className={this.getShapeIconClass('OVALS')} onMouseDown={() => { this.toggleShape('OVALS') }}></div>
          <div className={this.getShapeIconClass('EMERALD')} onMouseDown={() => { this.toggleShape('EMERALD') }}></div>
          <div className={this.getShapeIconClass('PEAR')} onMouseDown={() => { this.toggleShape('PEAR') }}></div>
          <div className={this.getShapeIconClass('CUSHION')} onMouseDown={() => { this.toggleShape('CUSHION') }}></div>
          <div className={this.getShapeIconClass('PRINCESS')} onMouseDown={() => { this.toggleShape('PRINCESS') }}></div>
          <div className={this.getShapeIconClass('RADIANT')} onMouseDown={() => { this.toggleShape('RADIANT') }}></div>
          <div className={this.getShapeIconClass('MARQUISE')} onMouseDown={() => { this.toggleShape('MARQUISE') }}></div>
          <div className={this.getShapeIconClass('ASCHER')} onMouseDown={() => { this.toggleShape('ASCHER') }}></div>
          <div className={this.getShapeIconClass('HEART')} onMouseDown={() => { this.toggleShape('HEART') }}></div>
        </div>
        <div className='shapePreload'>
          <div className={'shapeIcon ROUNDS selected'}></div>
          <div className={'shapeIcon OVALS selected'}></div>
          <div className={'shapeIcon EMERALD selected'}></div>
          <div className={'shapeIcon PEAR selected'}></div>
          <div className={'shapeIcon CUSHION selected'}></div>
          <div className={'shapeIcon PRINCESS selected'}></div>
          <div className={'shapeIcon RADIANT selected'}></div>
          <div className={'shapeIcon MARQUISE selected'}></div>
          <div className={'shapeIcon ASCHER selected'}></div>
          <div className={'shapeIcon HEART selected'}></div>
        </div>
      </div>
      <div className='filterSection'>
        <div className='originBlock'>
          <div className='blockTitle'>Origin</div>
          <div className={'radioGroup centerGroup secondColor'}>
            <div 
              className={this.state.isNatural ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setNatural(true)}>
              <div className='radioLabel'>Natural</div>
            </div>
            <div 
              className={!this.state.isNatural ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setNatural(false)}>
              <div className='radioLabel'>Lab Grown</div>
            </div>
          </div>
        </div>
        <div className='caratBlock'>
          <div className='blockTitle'>Carat</div>
          <div className='rangeWrapper'>
            <div className='rangeInput'>
              <input 
                className='rangeElement'
                placeholder='0.0'
                type='number'
                value={this.state.caratMin}
                onChange={this.changeCaratMin.bind(this)}
                onBlur={this.validateCaratMin.bind(this)}
                min={0.5}
                max={this.state.caratMax}
                step={0.1} />
            </div>
            <div className='rangeTo'>to</div>
            <div className='rangeInput'>
              <input 
                className='rangeElement' 
                placeholder='20.0'
                type='number'
                value={this.state.caratMax}
                onChange={this.changeCaratMax.bind(this)}
                onBlur={this.validateCaratMax.bind(this)}
                min={this.state.caratMin}
                max={20}
                step={0.1} />
            </div>
          </div>
        </div>
        <div className='colorBlock'>
          <div className='blockTitle'>Color</div>
          <div className={'radioGroup leftGroup secondColor'}>
            <div 
              className={this.state.color.indexOf('D') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('D')}>
              <div className='radioLabel'>D</div>
            </div>
            <div 
              className={this.state.color.indexOf('E') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('E')}>
              <div className='radioLabel'>E</div>
            </div>
            <div 
              className={this.state.color.indexOf('F') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('F')}>
              <div className='radioLabel'>F</div>
            </div>
            <div 
              className={this.state.color.indexOf('G') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('G')}>
              <div className='radioLabel'>G</div>
            </div>
            <div 
              className={this.state.color.indexOf('H') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('H')}>
              <div className='radioLabel'>H</div>
            </div>
            <div 
              className={this.state.color.indexOf('I') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('I')}>
              <div className='radioLabel'>I</div>
            </div>
            <div 
              className={this.state.color.indexOf('J') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('J')}>
              <div className='radioLabel'>J</div>
            </div>
            <div 
              className={this.state.color.indexOf('K') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('K')}>
              <div className='radioLabel'>K</div>
            </div>
            <div 
              className={this.state.color.indexOf('L') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('L')}>
              <div className='radioLabel'>L</div>
            </div>
            <div 
              className={this.state.color.indexOf('M') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('M')}>
              <div className='radioLabel'>M</div>
            </div>
            <div 
              className={this.state.color.indexOf('N') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('N')}>
              <div className='radioLabel'>N</div>
            </div>
            <div 
              className={this.state.color.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setColor('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>
        <div className='clarityBlock'>
          <div className='blockTitle'>Clarity</div>
          <div className={'radioGroup leftGroup'}>
            <div 
              className={this.state.clarity.indexOf('IF') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setClarity('IF')}>
              <div className='radioLabel'>IF</div>
            </div>
            <div 
              className={this.state.clarity.indexOf('VVS1') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setClarity('VVS1')}>
              <div className='radioLabel'>VVS1</div>
            </div>
            <div 
              className={this.state.clarity.indexOf('VVS2') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setClarity('VVS2')}>
              <div className='radioLabel'>VVS2</div>
            </div>
            <div 
              className={this.state.clarity.indexOf('VS1') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setClarity('VS1')}>
              <div className='radioLabel'>VS1</div>
            </div>
            <div 
              className={this.state.clarity.indexOf('VS2') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setClarity('VS2')}>
              <div className='radioLabel'>VS2</div>
            </div>
            <div 
              className={this.state.clarity.indexOf('SI1') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setClarity('SI1')}>
              <div className='radioLabel'>SI1</div>
            </div>
            <div 
              className={this.state.clarity.indexOf('SI2') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setClarity('SI2')}>
              <div className='radioLabel'>SI2</div>
            </div>
            <div 
              className={this.state.clarity.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setClarity('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>
        <div className={this.onlyRoundSelected() ? 'cutBlock' : 'cutBlock inactiveBlock'}>
          <div className='blockTitle'>Cut</div>
          <div className={'radioGroup centerGroup'}>
            <div 
              className={this.state.cut.indexOf('EX') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCut('EX')}>
              <div className='radioLabel'>EX</div>
            </div>
            <div 
              className={this.state.cut.indexOf('VG') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCut('VG')}>
              <div className='radioLabel'>VG</div>
            </div>
            <div 
              className={this.state.cut.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCut('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>
        <div className='labBlock' style={{display: 'none'}}>
          <div className='blockTitle'>Lab</div>
          <div className={'radioGroup leftGroup'}>
            <div 
              className={this.state.lab.indexOf('GIA') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setLab('GIA')}>
              <div className='radioLabel'>GIA</div>
            </div>
            <div 
              className={this.state.lab.indexOf('DD') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setLab('DD')}>
              <div className='radioLabel'>DD</div>
            </div>
            <div 
              className={this.state.lab.indexOf('Other') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setLab('Other')}>
              <div className='radioLabel'>Other</div>
            </div>
            <div 
              className={this.state.lab.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setLab('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>
        <div className='advancedSearchToggle' onClick={this.toggleAdvanced.bind(this)}>
          <div className={this.state.advancedOpen ? 'advancedSearchArrow open' : 'advancedSearchArrow'}>
            <img src='/img/diamonds/arrow.svg' />
          </div>
          <div className='advancedSearchLabel'>Advanced Search</div>
        </div>
        <div className={this.state.advancedOpen ? 'advancedSearchSection open' : 'advancedSearchSection'}>
          <div className='assetBlock' style={{display: 'none'}}>
            <div className='blockTitle'>Diamond Media</div>
            <div className={'radioGroup'}>
              <div 
                className={this.state.assets.indexOf('Image') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setAssets('Image')}>
                <div className='radioLabel'>Image</div>
              </div>
              <div 
                className={this.state.assets.indexOf('Video') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setAssets('Video')}>
                <div className='radioLabel'>Video</div>
              </div>
              <div 
                className={this.state.assets.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setAssets('All')}>
                <div className='radioLabel'>All</div>
              </div>
            </div>
          </div>
          <div className='walletBlock' style={{display: 'none'}}>
            <div className='blockTitle'>Diamond Mounting</div>
            <div className={'radioGroup'}>
              <div 
                className={this.state.wallet.indexOf('Loose') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setWallet('Loose')}>
                <div className='radioLabel'>Loose</div>
              </div>
              <div 
                className={this.state.wallet.indexOf('Mounted') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setWallet('Mounted')}>
                <div className='radioLabel'>Mounted</div>
              </div>
              <div 
                className={this.state.wallet.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setWallet('All')}>
                <div className='radioLabel'>All</div>
              </div>
            </div>
          </div>
          <div className='priceBlock' ref={(div) => { this.priceBlock = div; }}>
            <div className='blockTitle'>Price</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0'
                  type='number'
                  value={this.state.priceMin}
                  onChange={this.changePriceMin.bind(this)}
                  onBlur={this.validatePriceMin.bind(this)}
                  min={0}
                  max={this.state.priceMax}
                  step={1} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='1,000,000'
                  type='number'
                  value={this.state.priceMax}
                  onChange={this.changePriceMax.bind(this)}
                  onBlur={this.validatePriceMax.bind(this)}
                  min={this.state.priceMin}
                  max={1000000}
                  step={1} />
              </div>
            </div>
          </div>
          {isLoggedIn() ?
            <div className='costBlock' ref={(div) => { this.costBlock = div; }}>
              <div className='blockTitle'>Cost</div>
              <div className='rangeWrapper'>
                <div className='rangeInput'>
                  <input 
                    className='rangeElement'
                    placeholder='0'
                    type='number'
                    value={this.state.costMin}
                    onChange={this.changeCostMin.bind(this)}
                    onBlur={this.validateCostMin.bind(this)}
                    min={0}
                    max={this.state.costMax}
                    step={1} />
                </div>
                <div className='rangeTo'>to</div>
                <div className='rangeInput'>
                  <input 
                    className='rangeElement' 
                    placeholder='1,000,000'
                    type='number'
                    value={this.state.costMax}
                    onChange={this.changeCostMax.bind(this)}
                    onBlur={this.validateCostMax.bind(this)}
                    min={this.state.costMin}
                    max={1000000}
                    step={1} />
                </div>
              </div>
            </div> :
            null
          }
          <div className='ownershipBlock' style={{display: 'none'}}>
            <div className='blockTitle'>Ownership</div>
            <div className={'radioGroup'}>
              <div 
                className={this.state.ownership.indexOf('OW') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setOwnership('OW')}>
                <div className='radioLabel'>Owned</div>
              </div>
              <div 
                className={this.state.ownership.indexOf('ME') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setOwnership('ME')}>
                <div className='radioLabel'>Memo</div>
              </div>
              <div 
                className={this.state.ownership.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setOwnership('All')}>
                <div className='radioLabel'>All</div>
              </div>
            </div>
          </div>
          <div className='polishBlock'>
            <div className='blockTitle'>Polish</div>
            <div className={'radioGroup centerGroup'}>
              <div 
                className={this.state.polish.indexOf('EX') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setPolish('EX')}>
                <div className='radioLabel'>EX</div>
              </div>
              <div 
                className={this.state.polish.indexOf('VG') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setPolish('VG')}>
                <div className='radioLabel'>VG</div>
              </div>
              <div 
                className={this.state.polish.indexOf('G') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setPolish('G')}>
                <div className='radioLabel'>G</div>
              </div>
              <div 
                className={this.state.polish.indexOf('Fair') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setPolish('Fair')}>
                <div className='radioLabel'>Fair</div>
              </div>
              <div 
                className={this.state.polish.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setPolish('All')}>
                <div className='radioLabel'>All</div>
              </div>
            </div>
          </div>
          <div className='symmetryBlock'>
            <div className='blockTitle'>Symmetry</div>
            <div className={'radioGroup centerGroup'}>
              <div 
                className={this.state.symmetry.indexOf('EX') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setSymmetry('EX')}>
                <div className='radioLabel'>EX</div>
              </div>
              <div 
                className={this.state.symmetry.indexOf('VG') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setSymmetry('VG')}>
                <div className='radioLabel'>VG</div>
              </div>
              <div 
                className={this.state.symmetry.indexOf('G') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setSymmetry('G')}>
                <div className='radioLabel'>G</div>
              </div>
              <div 
                className={this.state.symmetry.indexOf('Fair') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setSymmetry('Fair')}>
                <div className='radioLabel'>Fair</div>
              </div>
              <div 
                className={this.state.symmetry.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setSymmetry('All')}>
                <div className='radioLabel'>All</div>
              </div>
            </div>
          </div>
          <div className='flourescenceBlock'>
            <div className='blockTitle'>Fluorescence</div>
            <div className={'radioGroup centerGroup'}>
              <div 
                className={this.state.flourescence.indexOf('Very Strong') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setFluorescence('Very Strong')}>
                <div className='radioLabel'>Very Strong</div>
              </div>
              <div 
                className={this.state.flourescence.indexOf('Strong') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setFluorescence('Strong')}>
                <div className='radioLabel'>Strong</div>
              </div>
              <div 
                className={this.state.flourescence.indexOf('Medium') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setFluorescence('Medium')}>
                <div className='radioLabel'>Medium</div>
              </div>
              <div 
                className={this.state.flourescence.indexOf('Faint') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setFluorescence('Faint')}>
                <div className='radioLabel'>Faint</div>
              </div>
              <div 
                className={this.state.flourescence.indexOf('None') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setFluorescence('None')}>
                <div className='radioLabel'>None</div>
              </div>
              <div 
                className={this.state.flourescence.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setFluorescence('All')}>
                <div className='radioLabel'>All</div>
              </div>
            </div>
          </div>
          <div className='tableBlock'>
            <div className='blockTitle'>Length (mm)</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0.00'
                  type='number'
                  value={this.state.lengthMin}
                  onChange={this.changeLengthMin.bind(this)}
                  onBlur={this.validateLengthMin.bind(this)}
                  min={0}
                  max={this.state.lengthMax}
                  step={0.01} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='100.00'
                  type='number'
                  value={this.state.lengthMax}
                  onChange={this.changeLengthMax.bind(this)}
                  onBlur={this.validateLengthMax.bind(this)}
                  min={this.state.lengthMin}
                  max={100}
                  step={0.01} />
              </div>
            </div>
          </div>
          <div className='tableBlock'>
            <div className='blockTitle'>Width (mm)</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0.00'
                  type='number'
                  value={this.state.widthMin}
                  onChange={this.changeWidthMin.bind(this)}
                  onBlur={this.validateWidthMin.bind(this)}
                  min={0}
                  max={this.state.widthMax}
                  step={0.01} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='100.00'
                  type='number'
                  value={this.state.widthMax}
                  onChange={this.changeWidthMax.bind(this)}
                  onBlur={this.validateWidthMax.bind(this)}
                  min={this.state.widthMin}
                  max={100}
                  step={0.01} />
              </div>
            </div>
          </div>
          <div className='tableBlock'>
            <div className='blockTitle'>Depth (mm)</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0.00'
                  type='number'
                  value={this.state.heightMin}
                  onChange={this.changeHeightMin.bind(this)}
                  onBlur={this.validateHeightMin.bind(this)}
                  min={0}
                  max={this.state.heightMax}
                  step={0.01} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='100.00'
                  type='number'
                  value={this.state.heightMax}
                  onChange={this.changeHeightMax.bind(this)}
                  onBlur={this.validateHeightMax.bind(this)}
                  min={this.state.heightMin}
                  max={100}
                  step={0.01} />
              </div>
            </div>
          </div>
          <div className='tableBlock' style={{ display: 'none' }}>
            <div className='blockTitle'>Table (%)</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0'
                  type='number'
                  value={this.state.tableMin}
                  onChange={this.changeTableMin.bind(this)}
                  onBlur={this.validateTableMin.bind(this)}
                  min={0}
                  max={this.state.tableMax}
                  step={1} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='100'
                  type='number'
                  value={this.state.tableMax}
                  onChange={this.changeTableMax.bind(this)}
                  onBlur={this.validateTableMax.bind(this)}
                  min={this.state.tableMin}
                  max={100}
                  step={1} />
              </div>
            </div>
          </div>
          <div className='depthBlock' ref={(div) => { this.depthBlock = div; }} style={{ display: 'none' }}>
            <div className='blockTitle'>Depth (%)</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0'
                  type='number'
                  value={this.state.depthMin}
                  onChange={this.changeDepthMin.bind(this)}
                  onBlur={this.validateDepthMin.bind(this)}
                  min={0}
                  max={this.state.depthMax}
                  step={1} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='100'
                  type='number'
                  value={this.state.depthMax}
                  onChange={this.changeDepthMax.bind(this)}
                  onBlur={this.validateDepthMax.bind(this)}
                  min={this.state.depthMin}
                  max={100}
                  step={1} />
              </div>
            </div>
          </div>
          <div className='ratioBlock'>
            <div className='blockTitle'>Ratio</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0.00'
                  type='number'
                  value={this.state.ratioMin}
                  onChange={this.changeRatioMin.bind(this)}
                  onBlur={this.validateRatioMin.bind(this)}
                  min={0}
                  max={this.state.ratioMax}
                  step={0.01} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='5.00'
                  type='number'
                  value={this.state.ratioMax}
                  onChange={this.changeRatioMax.bind(this)}
                  onBlur={this.validateRatioMax.bind(this)}
                  min={this.state.ratioMin}
                  max={5}
                  step={0.01} />
              </div>
            </div>
          </div>
          <div className='locationsBlock' style={{display: 'none'}}>
            <div className='blockTitle'>Location</div>
            <div className={'radioGroup locationRadio'}>
              <div 
                className={this.state.locations.indexOf(getLocationId('Atlanta')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Atlanta'))}>
                <div className='radioLabel'>Atlanta</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Austin')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Austin'))}>
                <div className='radioLabel'>Austin</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Birmingham')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Birmingham'))}>
                <div className='radioLabel'>Birmingham</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Boca Raton')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Boca Raton'))}>
                <div className='radioLabel'>Boca Raton</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Charleston')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Charleston'))}>
                <div className='radioLabel'>Charleston</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Charlotte')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Charlotte'))}>
                <div className='radioLabel'>Charlotte</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Cleveland')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Cleveland'))}>
                <div className='radioLabel'>Cleveland</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Columbus')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Columbus'))}>
                <div className='radioLabel'>Columbus</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Dallas')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Dallas'))}>
                <div className='radioLabel'>Dallas</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Fort Worth')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Fort Worth'))}>
                <div className='radioLabel'>Fort Worth</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Frisco')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Frisco'))}>
                <div className='radioLabel'>Frisco</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Greenville')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Greenville'))}>
                <div className='radioLabel'>Greenville</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Houston')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Houston'))}>
                <div className='radioLabel'>Houston</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Indianapolis')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Indianapolis'))}>
                <div className='radioLabel'>Indianapolis</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Jacksonville')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Jacksonville'))}>
                <div className='radioLabel'>Jacksonville</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Kansas City')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Kansas City'))}>
                <div className='radioLabel'>Kansas City</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('New Orleans')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('New Orleans'))}>
                <div className='radioLabel'>New Orleans</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Oklahoma City')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Oklahoma City'))}>
                <div className='radioLabel'>Oklahoma City</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Orlando')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Orlando'))}>
                <div className='radioLabel'>Orlando</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Palm Beach')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Palm Beach'))}>
                <div className='radioLabel'>Palm Beach</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Pittsburgh')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Pittsburgh'))}>
                <div className='radioLabel'>Pittsburgh</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Raleigh')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Raleigh'))}>
                <div className='radioLabel'>Raleigh</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Richmond')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Richmond'))}>
                <div className='radioLabel'>Richmond</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('St. Louis')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('St. Louis'))}>
                <div className='radioLabel'>St. Louis</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('San Antonio')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('San Antonio'))}>
                <div className='radioLabel'>San Antonio</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Virginia Beach')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Virginia Beach'))}>
                <div className='radioLabel'>Virginia Beach</div>
              </div>
              <div 
                className={this.state.locations.indexOf(getLocationId('Woodlands')) > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations(getLocationId('Woodlands'))}>
                <div className='radioLabel'>Woodlands</div>
              </div>
              <div 
                className={this.state.locations.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
                onClick={() => this.setLocations('All')}>
                <div className='radioLabel'>All</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={'searchSubmit bottomAction refreshIcon'} onClick={this.handleSubmit.bind(this)}>
        Search
        <div className='iconWrapper' onClick={this.resetSearch.bind(this)}>
          <img src='/img/icons/reset.svg' />
        </div>
      </div>
      <div className='bottomActionSpacer'></div>
		</div>;
	}
}
export default DiamondsOnline;

function mapStateToProps(state) {
  return {
    diamonds: state.diamonds,
  };
}

export const DiamondsOnlineContainer = connect(
  mapStateToProps,
  allActionCreators
)(DiamondsOnline);